import React from 'react';
import './ProgramatorLuni.css'

import { Fab, Button, Hidden } from '@material-ui/core';
import SpecificComponent from '../SpecificComponent';
import Utils from '../../providers/Utils';
import Masks from '../../providers/Masks';

export default class ProgramatorLuni extends SpecificComponent {

    constructor(props) {
        super(props);

        this.state = {
            title: '',

        }

    }

    m = new Masks()
    u = new Utils();


    monthDisplay = (luna, anul) => {

        let monthBegin = new Date(anul, (luna - 1), 1) // js index luna este 0
        let monthEnd = new Date(anul, luna, 0)

        // console.log('Inceput luna este -> ', monthBegin)
        // console.log('Sfarsit luna este -> ', monthEnd)

        let beginFor = this.getWeekNumber(monthBegin, luna);
        let endFor = this.getWeekNumber(monthEnd, luna);





        if (endFor < beginFor) {
            endFor = beginFor + endFor
        }

        // console.log('begin for =', beginFor);
        // console.log('end for = ', endFor);


        let tbodyContent = []
        let _td = new Date()
        let _day = 0;

        for (let i = beginFor; i <= endFor; i++) {
            let cols = []

            for (let k = 1; k <= 7; k++) {

                let celContent = []

                for (let j = 0; j < monthEnd.getDate(); j++) {

                    _td = this.addDays(monthBegin, j)
                    _day = _td.getDay() === 0 ? 7 : _td.getDay()


                    let weekIn = i

                    if (weekIn > 53) {
                        weekIn = i - 53
                    }

                    if (this.getWeekNumber(_td, luna) === weekIn && _day === k) {
                        // doar display brut de calendar
                        //celContent.push(<label key={`i=${i}k=${k}j=${j}`}>{_td.getDate()}</label>)
                        // console.log('this.props.dataProgramare :', this.props.dataProgramare.substring());
                        // console.log('_td :', _td);
                        celContent.push(<div style={{ overflow: 'hidden', position: 'relative', textAlign: 'center' }} className={_day >= 6 ? 'monthcalendar-weekend-class' : 'monthcalendar-weekday-class'} key={`i=${i}k=${k}j=${j}`}>
                            <label className={_day >= 6 ? 'monthcalendar-weekend-label' : 'monthcalendar-weekday-label'} > {_td.getDate()} </label>


                            <span><div style={{
                                backgroundColor: this.filterEvenimente(_td),
                                width: this.filterEvenimente(_td) === 'rgb(135 226 167)' ? 5 : 10,
                                height: this.filterEvenimente(_td) === 'rgb(135 226 167)' ? 5 : 10,
                                borderRadius: '50%',
                                margin: 'auto',
                                marginTop: 5
                            }}></div></span>

                            {this.m.datesAreEgual(new Date(this.u.defaultData()), new Date(_td)) && <div style={{
                                height: 4,
                                width: '100%',
                                backgroundColor: 'rgb(62	138	230)',
                                position: 'absolute',
                                bottom: 0
                            }}></div>}



                            {/* {
                                             this.filterLabelEvents(_td, i, k, monthEnd.getDate()) 
                                             }   */}

                        </div>)
                    }
                }

                cols.push(<td key={`w${i}d${k}`}> {celContent}  </td>)
            }

            tbodyContent.push(<tr key={`w${i}`}>{cols}</tr>)
        }


        // console.log('body content',tbodyContent);
        return tbodyContent
    }



    getWeekNumber = (d, luna) => {

        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        let dayNum = d.getUTCDay() || 7
        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

        if (weekNo === 1 && luna === 12) {
            let ld = new Date(d.getFullYear(), 11, 24);
            return this.getWeekNumber(ld) + 1
        } else {
            return weekNo
        }
    }

    ajustareSfarsitAn = (anul) => {
        return this.weeksInYear(anul) + 1
    }

    weeksInYear = (year) => {
        var d = new Date(year, 11, 31);
        var week = this.getWeekNumber(d);
        // console.log('saptamana :', week);
        if (week === 1) {
            d.setDate(24)
            return this.getWeekNumber(d)
        } else {
            return week
        }

    }





    daysInMonth = (month, year) => {

        return new Date(year, month, 0).getDate();
    }

    addDays = (date, days) => {

        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }


    filterEvenimenteObj = (dt) => {
        let u = new Utils();

        let dataCalendar = u.transformDataForSql(dt)

        console.warn('dataCalendar :>> ', dataCalendar);


        let evenimente = [...this.props.evenimente]
        
        console.warn('evenimente :>> ', evenimente);

        let eveniment = {}

        for (let i = 0, n = evenimente.length; i < n; i++) {


       

            if (evenimente[i].prezent_azi === 1) {


                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    // console.log('evenimente[i] :>> ', evenimente[i]);
                    eveniment = evenimente[i]
                }
            } else if (evenimente[i].absent_azi === 1) {

                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    eveniment = evenimente[i]
                }
            } else if (evenimente[i].tip === 'absenta_invoire') {
                console.warn('eveniment tip :>> ', evenimente[i]);

                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    eveniment = evenimente[i]
                }
            }else if(evenimente[i].tip === 'invoire'){
                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    eveniment = evenimente[i]
                }
            }else if (evenimente[i].tip === 'ore_suplimentare'){
                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    eveniment = evenimente[i]
                }
            }
            
            
            
            
            else {
                if (u.compareDate(dataCalendar, evenimente[i].cand_inceput_dataC) && u.compareDate(evenimente[i].cand_sfarsit_dataC, dataCalendar)) {
                    eveniment = evenimente[i]
                }
            }
        }

        console.warn('eveniment :>> ', eveniment);

        this.props.openEveniment(eveniment)

    }

    filterEvenimente = (dt) => {

        // console.log('dt :>> ', dt);

        let u = new Utils();

        let dataCalendar = u.transformDataForSql(dt)

        // console.log('dataCalendar :>> ', dataCalendar);


        let evenimente = [...this.props.evenimente]


        for (let i = 0, n = evenimente.length; i < n; i++) {



            if (evenimente[i].prezent_azi === 1) {


                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    // console.log('evenimente[i] :>> ', evenimente[i]);
                    return (evenimente[i].color)
                }
            } else if (evenimente[i].absent_azi === 1) {

                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    return (evenimente[i].color)
                }
            } else if (evenimente[i].tip === 'absenta_invoire') {
                console.warn('eveniment tip :>> ', evenimente[i]);

                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    return (evenimente[i].color)
                }
            }else if(evenimente[i].tip === 'invoire'){
                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    return (evenimente[i].color)
                }
            }else if (evenimente[i].tip === 'ore_suplimentare'){
                if (this.m.datesAreEgual(new Date(evenimente[i].la_data), new Date(dataCalendar))) {
                    return (evenimente[i].color)
                }
            }
            
            
            
            
            
            else {
                if (u.compareDate(dataCalendar, evenimente[i].cand_inceput_dataC) && u.compareDate(evenimente[i].cand_sfarsit_dataC, dataCalendar)) {
                    console.log('this.props.angajat :>> ', this.props.angajat);

                    let idxProgram = this.props.angajat['zile_libere'].findIndex( p => p === new Date(dataCalendar).getDay())
                    console.log('idxProgram :>> ', idxProgram);
                    console.log('dt :>> ', dt);

                    if(idxProgram === -1){

                        return (evenimente[i].color)
                    }else{
                        return 'transparent'
                    }
                }
            }
        }
    }




    filterLabel = (dt) => {
        if (this.props.scop === 'angajat') {
            let u = new Utils();
            let dataCalendar = u.transformDataForSql(dt);

            let cloneEvents = this.props.events

            let prezenta = []
            let counter = cloneEvents.length

            // console.log('cloneEvents :', cloneEvents);

            for (let i = 0, n = cloneEvents.length; i < n; i++) {
                cloneEvents[i].la_data = u.ParseDataFromSql(cloneEvents[i].la_data)


                if (cloneEvents[i].la_data === dataCalendar) {
                    prezenta.push(cloneEvents[i])

                }




            }

            let concediu = cloneEvents.findIndex(c => dataCalendar >= u.ParseDataFromSql(c.cand_inceput_dataC) && dataCalendar <= u.ParseDataFromSql(c.cand_sfarsit_dataC))

            let procent = 0


            if (prezenta.length > 0) {
                procent = prezenta[0].nr_ore_lucrate / 8 * 100

            }
            //  console.log('concediu :', concediu);

            if (procent > 100) {
                return prezenta[0].nr_ore_lucrate + ' ore'
            } else if (procent === 100) {
                return prezenta[0].nr_ore_lucrate + ' ore'
            } else if (procent < 100 && procent > 0) {
                return prezenta[0].nr_ore_lucrate + ' ore'
            } else if (concediu !== -1) {
                return 'Concediu / Absenta Motivata'
            }

            else {
                return 'Absent'
            }

        }

    }

    filterColor = (dt) => {

        if (this.props.scop === 'angajat') {
            let u = new Utils();
            let dataCalendar = u.transformDataForSql(dt);

            let cloneEvents = this.props.events

            let prezenta = []
            let counter = cloneEvents.length

            // console.log('cloneEvents :', cloneEvents);

            for (let i = 0, n = cloneEvents.length; i < n; i++) {
                cloneEvents[i].la_data = u.ParseDataFromSql(cloneEvents[i].la_data)

                if (cloneEvents[i].la_data === dataCalendar) {
                    prezenta.push(cloneEvents[i])

                }
            }
            let procent = 0
            let concediu = cloneEvents.findIndex(c => dataCalendar >= u.ParseDataFromSql(c.cand_inceput_dataC) && dataCalendar <= u.ParseDataFromSql(c.cand_sfarsit_dataC))


            if (prezenta.length > 0) {
                procent = prezenta[0].nr_ore_lucrate / 8 * 100
                concediu = prezenta[0].id_concediu
            }
            // console.log('procent :', procent);

            if (procent > 100) {
                return '#149514'
            } else if (procent === 100) {
                return '#21D621'
            } else if (procent < 100 && procent > 0) {
                return '#FF9300'
            } else if (concediu !== -1) {
                return '#5690d8'
            }

            else {
                return 'red'
            }

        }

        else {
            let u = new Utils();

            let dataCalendar = u.transformDataForSql(dt);

            let cloneEvents = this.props.events





            let prezenta = []
            let counter = cloneEvents.length

            for (let i = 0; i < counter; i++) {
                cloneEvents[i].la_data = u.ParseDataFromSql(cloneEvents[i].la_data)

                if (cloneEvents[i].la_data === dataCalendar) {
                    if (cloneEvents[i].prezenta !== 0) {

                        prezenta.push(cloneEvents[i])
                    }
                }

            }

            let procent = 0



            if (prezenta.length > 0) {
                procent = prezenta.length / this.props.totalAngajati.length * 100
            }


            if (procent >= 80) {
                return 'green'
            } else if (procent < 80 && procent > 50) {
                return 'orange'
            } else {
                return 'red'
            }




        }




    }

    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }

    changeView = () => {
        let clickable = this.props.changeble ? this.props.changeble : false


        if (clickable) {
            this.props.changeView()
        } else {
            return false
        }
    }


    render() {
        return (
            <div style={{ display: this.props.display, maxWidth: this.props.maxWidth }} className="monthcalendar-main-container">

                <div style={{ marginTop: 20, textAlign: 'center' }} className='monthcalendar-header'>
                    <i onClick={this.props.minusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_left</i>
                    <span onClick={this.changeView} style={{ fontSize: 18, verticalAlign: 'text-bottom', textTransform: 'uppercase', cursor: 'pointer' }} className='monthcalendar-title'>
                        {this.numeLuna(new Date(this.props.dataStart).getMonth() + 1)} {new Date(this.props.dataStart).getFullYear()}

                    </span>
                    <i onClick={this.props.plusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_right</i>
                </div>


                <div className="monthcalendar-table-container">


                    <table className='monthcalendar-table-class'>
                        <thead className='monthcalendar-tablehead-class'>
                            <tr className='monthcalendar-tableheadtr-class' >
                                <th style={{ color: 'black', backgroundColor: 'rgb(250 250 250)', fontSize: 14, borderBottom: '1px solid rgb(242 242 242)', fontWeight: 400 }}>Lu</th>
                                <th style={{ color: 'black', backgroundColor: 'rgb(250 250 250)', fontSize: 14, borderBottom: '1px solid rgb(242 242 242)', fontWeight: 400 }}>Ma</th>
                                <th style={{ color: 'black', backgroundColor: 'rgb(250 250 250)', fontSize: 14, borderBottom: '1px solid rgb(242 242 242)', fontWeight: 400 }}>Mi</th>
                                <th style={{ color: 'black', backgroundColor: 'rgb(250 250 250)', fontSize: 14, borderBottom: '1px solid rgb(242 242 242)', fontWeight: 400 }}>Jo</th>
                                <th style={{ color: 'black', backgroundColor: 'rgb(250 250 250)', fontSize: 14, borderBottom: '1px solid rgb(242 242 242)', fontWeight: 400 }}>Vi</th>
                                <th style={{ color: 'white', backgroundColor: 'rgb(252	93	98)', fontSize: 14, fontWeight: 400 }}>Sa</th>
                                <th style={{ color: 'white', backgroundColor: 'rgb(252	93	98)', fontSize: 14, fontWeight: 400 }}>Du</th>
                            </tr>
                        </thead>

                        <tbody>
                            {this.monthDisplay(new Date(this.props.dataStart).getMonth() + 1, new Date(this.props.dataStart).getFullYear())}
                        </tbody>

                    </table>


                </div>
            </div>
        );
    }


}  // end class